const install = (Vue) => {
  const Bus = new Vue();
  Vue.prototype.$bus = Bus;
}
export default install;
